import { render, staticRenderFns } from "./projectExperience.vue?vue&type=template&id=22070298&scoped=true"
import script from "./projectExperience.vue?vue&type=script&lang=js"
export * from "./projectExperience.vue?vue&type=script&lang=js"
import style0 from "./projectExperience.vue?vue&type=style&index=0&id=22070298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22070298",
  null
  
)

export default component.exports